import styled from 'styled-components';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Bio } from '../../data/constants';
import { RoughDivider, chalkSquiggleBg } from '../common/Rough';
import { ChalkDoodles } from '../common/Doodles';

const FooterContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
  font-family: 'Caveat', cursive;
  font-weight: 700;
  font-size: 34px;
  color: ${({ theme }) => theme.text_primary};
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 800px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
`;

const NavLink = styled.a`
  position: relative;
  color: ${({ theme }) => theme.text_primary};
  font-family: 'Kalam', cursive;
  text-decoration: none;
  font-size: 1.2rem;
  padding-bottom: 6px;
  transition: color 0.2s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    left: -2px;
    right: -2px;
    bottom: 0;
    height: 10px;
    background-image: ${({ theme }) => chalkSquiggleBg(theme.primary)};
    background-repeat: repeat-x;
    background-size: 40px 10px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  &:hover::after {
    opacity: 1;
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;


function Footer() {
  return (
    <FooterContainer>
      <ChalkDoodles seedBase={31} count={5} />
      <RoughDivider height={20} style={{ maxWidth: 1200, width: '92%' }} />
      <FooterWrapper>
        <Logo>{Bio.name}</Logo>
        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
        </Nav>
        <SocialMediaIcons>
          <SocialMediaIcon href={Bio.GitHub} target="display"><GitHubIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.twitter} target="display"><TwitterIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.linkedin} target="display"><LinkedInIcon /></SocialMediaIcon>
        </SocialMediaIcons>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;